"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ActivateUser_exports = {};
__export(ActivateUser_exports, {
  default: () => ActivateUser_default
});
module.exports = __toCommonJS(ActivateUser_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.2461 9.68359C11.2096 9.68359 12.0234 9.34505 12.6875 8.66797C13.3646 7.99089 13.7031 7.17057 13.7031 6.20703C13.7031 5.25651 13.3646 4.44271 12.6875 3.76562C12.0234 3.08854 11.2096 2.75 10.2461 2.75C9.29557 2.75 8.48177 3.08854 7.80469 3.76562C7.1276 4.44271 6.78906 5.25651 6.78906 6.20703C6.78906 7.17057 7.1276 7.99089 7.80469 8.66797C8.48177 9.34505 9.29557 9.68359 10.2461 9.68359ZM10.2461 3.84375C10.8971 3.84375 11.4505 4.07812 11.9062 4.54688C12.375 5.0026 12.6094 5.55599 12.6094 6.20703C12.6094 6.87109 12.375 7.4375 11.9062 7.90625C11.4505 8.36198 10.8971 8.58984 10.2461 8.58984C9.59505 8.58984 9.03516 8.36198 8.56641 7.90625C8.11068 7.4375 7.88281 6.87109 7.88281 6.20703C7.88281 5.55599 8.11068 5.0026 8.56641 4.54688C9.03516 4.07812 9.59505 3.84375 10.2461 3.84375ZM14.7969 13.0625C14.9141 13.1667 15.0443 13.2188 15.1875 13.2188C15.3438 13.2057 15.474 13.1471 15.5781 13.043C15.6823 12.9388 15.7279 12.8086 15.7148 12.6523C15.7148 12.4961 15.6628 12.3659 15.5586 12.2617C15.181 11.9102 14.7513 11.6432 14.2695 11.4609C13.8008 11.2656 13.306 11.168 12.7852 11.168H7.78516C7.23828 11.168 6.72396 11.2656 6.24219 11.4609C5.76042 11.6693 5.33724 11.9427 4.97266 12.2812C4.62109 12.6198 4.34766 13.0234 4.15234 13.4922C3.94401 13.9479 3.83984 14.4427 3.83984 14.9766V16.2852C3.83984 16.4414 3.89193 16.5716 3.99609 16.6758C4.10026 16.7799 4.23047 16.832 4.38672 16.832C4.52995 16.832 4.65365 16.7799 4.75781 16.6758C4.875 16.5716 4.93359 16.4414 4.93359 16.2852V14.9766C4.93359 14.2214 5.20703 13.5833 5.75391 13.0625C6.3138 12.5286 6.99089 12.2617 7.78516 12.2617H12.7852C13.1628 12.2617 13.5273 12.3333 13.8789 12.4766C14.2305 12.6068 14.5365 12.8021 14.7969 13.0625ZM18.3711 12.7695C18.2539 12.6784 18.1172 12.6393 17.9609 12.6523C17.8177 12.6523 17.7005 12.7109 17.6094 12.8281L14.543 16.3828L13.5078 15.1914C13.4036 15.0872 13.2734 15.0286 13.1172 15.0156C12.974 15.0026 12.8438 15.0482 12.7266 15.1523C12.6224 15.2565 12.5638 15.3867 12.5508 15.543C12.5378 15.6862 12.5833 15.8099 12.6875 15.9141L14.1523 17.5742C14.2044 17.6263 14.263 17.6719 14.3281 17.7109C14.3932 17.737 14.4648 17.75 14.543 17.75H14.5625C14.6406 17.75 14.7122 17.737 14.7773 17.7109C14.8555 17.6719 14.9206 17.6198 14.9727 17.5547L18.4297 13.5508C18.5208 13.4336 18.5599 13.3034 18.5469 13.1602C18.5469 13.0039 18.4883 12.8737 18.3711 12.7695Z",
      fill: "currentColor"
    }
  )
);
const SvgActivateUser = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ActivateUser_default = SvgActivateUser;
